import { createMuiTheme, ThemeProvider as MUIThemeProvider } from '@material-ui/core';
import Recat from 'react';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#FF7417',
      contrastText: '#FFF'
    },
  },
  typography: {
    fontFamily: 'Montserrat, Arial'
  }
});

export default function ThemeProvider({ children }) {
  return (
    <MUIThemeProvider theme={theme}>
      {children}
    </MUIThemeProvider>
  )
}